import { render } from "./TheTemplateJ.vue?vue&type=template&id=3258274e&scoped=true&ts=true"
import script from "./TheTemplateJ.vue?vue&type=script&lang=ts"
export * from "./TheTemplateJ.vue?vue&type=script&lang=ts"

import "./TheTemplateJ.vue?vue&type=style&index=0&id=3258274e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3258274e"]])

export default __exports__